import { /* Circle, */ LayersControl, MapContainer, TileLayer } from 'react-leaflet'
import Markers from '../Map/Markers'
import React from 'react'

import '../Map/index.scss'
import 'leaflet/dist/leaflet.css'

interface MapSimpleProps{
  body:places.PlacesResponse | null
}

const MapSimple: React.FC<MapSimpleProps> = ({body}) => {

  return (
    <>
      <div className="map">
        <MapContainer
          zoom={6}
          minZoom={0}
          maxZoom={20}
          center={[52, 19]}
          className='map__leaflet'
          scrollWheelZoom={true}>

          <LayersControl>
            <LayersControl.BaseLayer checked name="Ulice">
              <TileLayer
                maxZoom={20}
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO Google</a>'
                url={`https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png`}
              />
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer name="Satelita">
              <TileLayer
                maxZoom={20}
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO Google</a>'
                url={`https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}`}
                subdomains={["mt0", "mt1", "mt2", "mt3"]}
              />
            </LayersControl.BaseLayer>
          </LayersControl>

          <Markers data={body}/>
        </MapContainer>
      </div>
    </>)
}

export default MapSimple